import { connect } from "react-redux";
import RefreshButton from "./RefreshButton";
import { setActiveEnvironmentById } from "store/environments/environment-actions";
import { setRefreshActivated } from "store/common/page-refresh/page-refresh-actions";

const RefreshButtonContainer = connect(null, {
    setActiveEnvironmentById,
    setRefreshActivated,
})(RefreshButton);

export default RefreshButtonContainer;
